const PRIVATE_ALL_REGULAR_PERIODS = [
  'day',
  'week',
  'fortnight',
  'month',
  'quarter',
  'year',
  'year_to_date',
] as const

// Hack to avoid having to declare everything as readonly
export const ALL_REGULAR_PERIODS = [...PRIVATE_ALL_REGULAR_PERIODS]

export type FixedDuration = (typeof ALL_REGULAR_PERIODS)[number]
